import { Typography, Box, useTheme, TextField, Divider, Autocomplete, Button, Grid, Dialog, Tooltip,DialogTitle, DialogContent, DialogActions } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallAlertBar from "../../Layout/Alertbar";
import { tokens } from "../../theme/theme";
import { callApi } from "../../utils/apiClient";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import useMaterialCategory from "../../hooks/useMaterialCategory";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import useMaterialShades from "../../hooks/useMaterialShades";
import DeleteForeverIcon from '@mui/icons-material/HighlightOff';
const AddMaterialShade = ({ onClose, handleBackWinderMachineEntry, open }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [result, setresult] = useState([]);
    const [selectedShade, setSelectedShade] = useState(null);
    //message are 
    const [parentRollMsgOpen, setParentRollMsgOpen] = useState(false);
    const [parentRollSeverityvalue, setParentRollSeverityvalue] = useState('info');
    const [parentRollMessageValue, setParentRollMessageValue] = useState('');
    const [parentRollAlertTitleValue, setParentRollAlertTitleValue] = useState('');
    // Custom hook to manage material shades

    const { materialShade, selectedShadeID, setSelectedShadeID, loadMaterialShadeByID } = useMaterialShades(0);


    const handleDeleteMaterialShade = (id) => {
        // show confirm dialog maybe?
        if (window.confirm("Are you sure you want to delete this material shade?")) {
            let requestBody = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_id_shade: id,
            };

            callApi(API_ENDPOINTS.MATERIAL_SHADE_DELETE_PROCESS, 'POST', { 'Content-Type': 'application/json' }, requestBody)
                .then(data => {
                    // Update state with fetched data

                    if (data[0].result_value == 0) {
                        // Show a notification when the PDF is downloaded successfully
                        toast.success('Material Shade deleted Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                        loadMaterialShadeByID(0);  // or whatever logic you use here               

                    }
                    else if (data[0].result_value == 1) {
                        // Show a notification when the PDF is downloaded successfully
                        toast.error('Material Shade has been added to materials. Please remove it from materials.', { position: toast.POSITION.BOTTOM_CENTER });
                    }

                })
                .catch(error => {
                    alert(error.message);
                });
        }
    };

    const MaterialShadeColumns = [
        {
            field: 'sno',
            headerName: 'S.No',
            width: 120,
            sortable: false,
            filterable: false,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1,
        },
        {
            field: "description",
            headerName: "Material Shade",
            flex: 1,
            cellClassName: "name-column--cell"

        },
        {
            field: "actions",
            headerName: "Actions",
            width: 100,
            sortable: false,
            filterable: false,
            renderCell: (params) => (
                <Tooltip title="Delete Material Shade">
                <IconButton
                    color="error"

                    onClick={() => handleDeleteMaterialShade(params.row.id_material_shade)}
                >
                    <DeleteForeverIcon style={{ fontSize: '22px' }} />
                </IconButton></Tooltip>
            )
        }
    ];




    const handleSaveMaterialShades = () => {
        setParentRollMsgOpen(false);
        // validation 
        let isValid = true;
        let validation_msg = '';

        if (selectedShade === '') {
            validation_msg += 'Please enter the material shade.\n';
            isValid = false;
        }

        if (isValid) {
            const SaveData = {
                p_companyid: localStorage.getItem('companyid'),
                p_plantid: 1,
                p_shade: selectedShade,
            }

            callApi(API_ENDPOINTS.MATERIAL_SHADE_CRUD_PROCESS, 'POST', { 'Content-Type': 'application/json' }, SaveData)
                .then(data => {
                    if (data && data.length > 0) {
                        setresult(data[0]);

                        if (data[0].result_value == 0) {
                            // Show a notification when the PDF is downloaded successfully
                            toast.success('New Material Shade Added Successfully.', { position: toast.POSITION.BOTTOM_CENTER });
                            loadMaterialShadeByID(0);  // or whatever logic you use here               

                        }
                        else if (data[0].result_value == 1) {
                            // Show a notification when the PDF is downloaded successfully
                            toast.error('Material Shade already exist.', { position: toast.POSITION.BOTTOM_CENTER });
                        }
                    }
                })
                .catch(error => {
                    alert(error.message);
                });
        }
        else {
            setParentRollSeverityvalue('warning');
            setParentRollMessageValue(validation_msg);
            setParentRollAlertTitleValue('info');
            setParentRollMsgOpen(true);
        }
    };



    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                style: {
                    alignSelf: 'flex-start',
                    margin: '0 auto',
                    position: 'relative',
                    top: '0px',
                },
            }}
            BackdropProps={{
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    paddingTop: '20px',
                    minHeight: '100vh',
                    background: 'rgba(0,0,0,0.5)',
                },
            }}
        >


            <DialogTitle style={{ backgroundColor: colors.primary[600], color: colors.primary }}>
                <Box display="flex" alignItems="center">
                    {/* <WarningRoundedIcon style={{ marginRight: 8, color: 'pink', fontSize: "32" }} /> Add icon with some margin */}
                    <Typography>Add Material Shade</Typography>
                </Box>

            </DialogTitle>
            <DialogContent style={{ backgroundColor: colors.primary[500], color: colors.primary }}>
                {/* Your modal content here */}


                <Box>
                    {/* <Header title="Add New Operator" subtitle="" callback={onClose} />
                        <Divider /> */}
                    {/* Message box detail */}
                    <CallAlertBar parentRollMsgOpen={parentRollMsgOpen} setParentRollMsgOpen={setParentRollMsgOpen} parentRollSeverityvalue={parentRollSeverityvalue}
                        setParentRollSeverityvalue={setParentRollSeverityvalue} parentRollAlertTitleValue={parentRollAlertTitleValue}
                        setParentRollAlertTitleValue={setParentRollAlertTitleValue} parentRollMessageValue={parentRollMessageValue} setParentRollMessageValue={setParentRollMessageValue} />


                    <Grid container spacing={2} sx={{ width: '100%', p: 0.5 }} >
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}  >


                            <Box
                                display="grid"
                                gridTemplateColumns={{
                                    xs: 'repeat(2, 1fr)',
                                    sm: 'repeat(2, 1fr)',
                                    md: 'repeat(3, 1fr)',
                                    lg: 'repeat(12, 1fr)',
                                    xl: 'repeat(12, 1fr)',
                                }}
                                gridAutoRows="10px"
                                gap={{ xs: '40px', sm: '40px', md: '40px', lg: '10px', xl: '5px' }}
                                marginTop={1}
                            >


                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 3',
                                        xl: 'span 3',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <Typography variant="h6"> Material Shade</Typography>
                                </Box>

                                <Box
                                    gridColumn={{
                                        xs: 'span 2',
                                        sm: 'span 11',
                                        md: 'span 11',
                                        lg: 'span 9',
                                        xl: 'span 9',
                                    }}
                                    display="flex"
                                    alignItems="start"
                                    justifyContent="start"

                                >
                                    <TextField value={selectedShade} color="secondary" onChange={(e) => setSelectedShade(e.target.value)} sx={{ '& .MuiOutlinedInput-root': { '& fieldset': { borderStyle: 'dot', } } }} fullWidth size="small" type="text" ></TextField>





                                </Box>



                            </Box>




                            <Box marginTop={5}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button onClick={handleSaveMaterialShades} size="small" variant="contained" color="secondary">
                                        Add
                                    </Button>
                                    {/* <Button size="small" sx={{ marginLeft: "10px" }} variant="contained" onClick={onClose} color="secondary">
                                        Cancel
                                    </Button> */}
                                </Box>
                            </Box>


                            {/* 
                                </CardContent>
                            </Card> */}

                            <Divider sx={{ marginTop: '20px' }} />


                            <Box marginTop={1}>
                                <Typography variant="h6" sx={{ marginTop: '10px', marginBottom: '10px' }}> Material Shade List</Typography>

                                <Box

                                    gridColumn="span 9"
                                    gridRow={"span 2"}
                                    alignItems="center"
                                    justifyContent="center"

                                    height="51vh"
                                    sx={{

                                        "& .MuiCheckbox-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },
                                        "& .Muidropdown-root": {
                                            color: `${colors.greenAccent[200]} !important`,
                                        },

                                        borderLeft: "0", // Remove left border
                                        borderRight: "0", // Remove right border
                                    }}
                                >
                                    <DataGrid name="dgv-orderselection" getRowId={(row) => row.id_material_shade} pageSize={5} columnHeaderHeight={35} rowHeight={40} rows={materialShade} columns={MaterialShadeColumns}


                                    />

                                </Box>
                            </Box>

                        </Grid>
                    </Grid>
                </Box>




            </DialogContent>
            <DialogActions style={{ backgroundColor: colors.primary[400] }}>



                <Button size='small' onClick={onClose} variant="contained" color="secondary" style={{ textTransform: 'none' }} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default AddMaterialShade;